import FamilleArticleViewPage from "@features/creation/famille-articles/components/FamilleArticleViewPage";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute, useParams } from "@tanstack/react-router";
import { Eye, FolderOpen } from "lucide-react";

export const Route = createFileRoute("/_app/creation/familleArticles/$id/view")({
  loader: requirePermission(PERMISSIONS.CREATION.FAMILLE_ARTICLES.VIEW),
  staticData: {
    title: "Détail famille",
    icon: Eye,
    permission: PERMISSIONS.CREATION.FAMILLE_ARTICLES.VIEW,
    module: "creation",
    section: "Creation",
    order: 15,
    showInNav: false,
    showInTab: false,
    showInBreadcrumb: true,
  },
  component: ViewFamilleArticlePage,
});

function ViewFamilleArticlePage() {
  const { id } = useParams({ from: "/_app/creation/familleArticles/$id/view" });
  return <FamilleArticleViewPage id={id} />;
}
